import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { ConstantsService } from "../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-brand-colors-modal',
  templateUrl: './brand-colors-modal.component.pug',
  styleUrls: ['./brand-colors-modal.component.scss'],
  standalone: false
})
export class BrandColorsModalComponent extends AbstractModalComponent implements OnInit {

  @Input() color!: string;
  @Input() secondary_color!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  defaultLogo = ConstantsService.DEFAULT_LOGO;
  hexcodePattern = '^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$';

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = { 'color': this.color, 'secondary_color': this.secondary_color };
    ;
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid) {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
